var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagAzerbaijan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_14929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 15.9999C32 14.0428 31.648 12.168 31.0048 10.4347L16 9.73901L0.995188 10.4346C0.352063 12.168 0 14.0428 0 15.9999C0 17.957 0.352063 19.8318 0.995188 21.5651L16 22.2608L31.0048 21.5651C31.648 19.8318 32 17.957 32 15.9999Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32C22.8794 32 28.7441 27.658 31.0048 21.5652H0.995186C3.25587 27.658 9.12056 32 16 32Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.995186 10.4348H31.0049C28.7441 4.342 22.8794 0 16 0C9.12056 0 3.25587 4.342 0.995186 10.4348Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3483 20.5218C13.851 20.5218 11.8265 18.4973 11.8265 16.0001C11.8265 13.5028 13.851 11.4783 16.3483 11.4783C17.1269 11.4783 17.8596 11.6752 18.4992 12.0218C17.4957 11.0405 16.1234 10.4348 14.6091 10.4348C11.5355 10.4348 9.04395 12.9264 9.04395 16C9.04395 19.0736 11.5356 21.5652 14.6091 21.5652C16.1235 21.5652 17.4958 20.9595 18.4992 19.9782C17.8596 20.3249 17.1269 20.5218 16.3483 20.5218Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8265 12.8696L20.4254 14.5541L22.0401 13.7864L21.2725 15.4011L22.9569 16.0001L21.2725 16.5991L22.0401 18.2137L20.4254 17.4461L19.8265 19.1305L19.2276 17.4461L17.6129 18.2137L18.3806 16.5991L16.6961 16.0001L18.3806 15.4011L17.6129 13.7864L19.2276 14.5541L19.8265 12.8696Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_14929"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagAzerbaijan);
export default __webpack_public_path__ + "static/media/flag_azerbaijan.f39ec902962c989a79465af8ebccf0bb.svg";
export { ForwardRef as ReactComponent };